// extracted by css-extract-rspack-plugin
export default {"root":"root-yegyz6","title":"title-uk6wRj"};